export const navList = [{
    label: "首页",
    path: "/sunShine"
}, {
    label: "服务咨询",
    path: "/sunShine/conduct"
}, {
    label: "定制方案",
    path: "/sunShine/consult"
}, {
    label: "前期资质办理",
    path: "/sunShine/customize"
}, {
    label: "入驻开展业务",
    path: "/sunShine/qualifications"
}, ]


// WEBPACK FOOTER //
// ./src/model/enter.js